@import "../../../../../shared/styles/base";

.RadioButton {
  display: flex;
  flex-direction: column;

  &.Disabled {
    opacity: 0.5;
  }

  & .Label {
    margin-bottom: 0;
    align-items: center;
    display: flex;
    cursor: pointer;
    line-height: 1.25;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 1.25rem;
    width: 1.25rem;
  }

  & .Radio {
    height: 1.25rem;
    width: 1.25rem;
    border: 1.5px solid $ds-neutral-300;
    border-radius: 100%;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.25rem;
  }

  input:focus ~ .Label .Radio {
    outline: $focus-outline;
    outline-offset: 1px;
  }

  input:checked ~ .Label .Radio {
    background-color: $ds-violet-500;
    border-color: $ds-violet-500;

    & svg {
      width: 100%;
      color: #fff;
      display: flex;
      opacity: 1;
    }
  }

  input:invalid ~ .Label .Radio {
    border-color: $ds-coral-600;
  }

  input:invalid:checked ~ .Label .Radio {
    background-color: $ds-coral-600;
  }
}

.RadioGroup {
  legend {
    display: block;
    font-size: $ds-font-size-b3;
    font-weight: $ds-font-weight-medium;

    &.Hidden {
      height: 0;
      overflow: hidden;
    }
  }

  &.Vertical .Options {
    display: flex;
    flex-direction: column;

    & .RadioButton + .RadioButton {
      margin-top: 0.5rem;
    }
  }

  &.Horizontal .Options {
    display: flex;
    flex-direction: row;

    .RadioButton {
      display: inline-block;

      &:not(:last-of-type) {
        margin-right: 1rem;
      }
    }
  }
}
